import { Component, OnInit } from '@angular/core';
import { BooleanCons, TypeListProduct } from 'src/app/constants/const';
import { IDoctorAdvisers } from 'src/app/model/http/profile.model';
import { CommonService } from 'src/app/services/common.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObservableService } from 'src/app/services/observable.service';

@Component({
  selector: 'app-advisors-doctor',
  templateUrl: './advisors-doctor.component.html',
  styleUrls: ['./advisors-doctor.component.scss']
})
export class AdvisorsDoctorComponent implements OnInit {
  typeListProduct = TypeListProduct;
  advisors: IDoctorAdvisers[] = [];
  constructor(
    private observableService: ObservableService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.observableService.getInfoIsLoading().subscribe(() => {
      this.getAdvisorsInfo();
    });
  }

  closeDialog(): void {
    this.observableService.setShowAdvisorModal(BooleanCons.false);
  }

  getAdvisorsInfo(): void {
    this.advisors = this.localStorageService.getHeaderInfo().doctorAdvisers;
    this.advisors.forEach(advisor => {
      advisor.initials = this.commonService.getInitialsName(`${advisor.name} ${advisor.lastName}`);
    });
  }
}
